import React, { useState, useEffect } from 'react';
import { apiService } from '../../../services/ApiService';
import { toast } from 'react-hot-toast';
import './CadastroClienteModal.css';

const CadastroClienteModal = ({ isOpen, onClose, idObra, userEmpresa }) => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    username: '',
    senha: '',
    empresa: userEmpresa,
    idObra: [idObra]
  });

  const [senhaValida, setSenhaValida] = useState({
    tamanho: false,
    letra: false,
    numero: false,
    especial: false
  });

  const [mostrarSenha, setMostrarSenha] = useState(false);

  useEffect(() => {
    // Validar senha quando ela mudar
    const senha = formData.senha;
    setSenhaValida({
      tamanho: senha.length >= 8,
      letra: /[a-zA-Z]/.test(senha),
      numero: /[0-9]/.test(senha),
      especial: /[!@#$%^&*(),.?":{}|<>]/.test(senha)
    });
  }, [formData.senha]);

  const senhaAtendeRequisitos = () => {
    return Object.values(senhaValida).every(valor => valor === true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!senhaAtendeRequisitos()) {
      toast.error('A senha não atende aos requisitos mínimos de segurança', {
        duration: 5000,
        style: {
          background: '#fff3f3',
          border: '1px solid #ffcdd2',
          color: '#d32f2f',
          padding: '16px',
          borderRadius: '4px',
          maxWidth: '500px'
        }
      });
      return;
    }

    try {
      const userData = {
        nome: formData.nome,
        email: formData.email,
        username: formData.username.toLowerCase(),
        senha: formData.senha,
        empresa: formData.empresa,
        role: 'client',
        idObra: formData.idObra
      };

      const response = await apiService.signup(userData);
      if (response.success) {
        toast.success('Cliente cadastrado com sucesso!');
        onClose();
      } else {
        toast.error(response.error || 'Erro ao cadastrar cliente');
      }
    } catch (error) {
      toast.error('Erro ao cadastrar cliente');
      console.error('Erro:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Cadastrar Cliente</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nome">Nome:</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              placeholder="Nome completo do cliente"
              required
              title="Digite o nome completo do cliente"
            />
            <small className="input-help">Nome completo do cliente que terá acesso à obra</small>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="cliente@empresa.com.br"
              required
              title="Digite o email que será usado para login"
            />
            <small className="input-help">Email que será usado para acessar o sistema</small>
          </div>
          <div className="form-group">
            <label htmlFor="username">Usuário:</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="usuario.cliente"
              required
              title="Digite um nome de usuário único para login"
            />
            <small className="input-help">Nome de usuário para login (sem espaços ou caracteres especiais)</small>
          </div>
          <div className="form-group">
            <label htmlFor="senha">Senha:</label>
            <div className="senha-input-container">
              <input
                type={mostrarSenha ? "text" : "password"}
                id="senha"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                placeholder="Digite uma senha forte"
                required
                title="Digite uma senha forte com letras, números e caracteres especiais"
                className={formData.senha && !senhaAtendeRequisitos() ? "senha-invalida" : ""}
              />
              <button
                type="button"
                className="btn-mostrar-senha"
                onClick={() => setMostrarSenha(!mostrarSenha)}
                title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
              >
                {mostrarSenha ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
            <div className="senha-requisitos">
              <p className="requisito-titulo">A senha deve conter:</p>
              <ul className="requisitos-lista">
                <li className={senhaValida.tamanho ? "requisito-atendido" : ""}>
                  {senhaValida.tamanho ? "✓" : "○"} Mínimo de 8 caracteres
                </li>
                <li className={senhaValida.letra ? "requisito-atendido" : ""}>
                  {senhaValida.letra ? "✓" : "○"} Pelo menos uma letra
                </li>
                <li className={senhaValida.numero ? "requisito-atendido" : ""}>
                  {senhaValida.numero ? "✓" : "○"} Pelo menos um número
                </li>
                <li className={senhaValida.especial ? "requisito-atendido" : ""}>
                  {senhaValida.especial ? "✓" : "○"} Pelo menos um caractere especial (!@#$%^&*)
                </li>
              </ul>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn-submit"
              disabled={!senhaAtendeRequisitos()}
            >
              Cadastrar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroClienteModal; 